@if(requests) {
  <div class="col-md-4 ps-0">
    <app-search-bar (search)="search = $event" [resultsCount]="(requests | search:search).length"></app-search-bar>
  </div>
}

<ls-dynamic-table [data]="requests | search:search"
                   [headers]="headers"
                   [actions]="actions"
                   currentSort="date">
  <ng-template let-item>
    <th scope="row" class="d-table-cell d-md-none pt-0">
      @if(!item.forContact) {
        @if(item.coords) {
          {{ item.coords.email }}
        } @else {
          Contact introuvable ou supprimé
        }
      } @else {
        <a target="_blank"
           [href]="(crmUrl | async) + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + item.forContact.crmId">{{ item.forContact.firstname }} {{ item.forContact.lastname }}</a>
      }
    </th>
    <td>
      @if(item.accepted === null) {
        @if(item.handledBy === null) {
          <span ngbTooltip="Non pris en charge">
            <fa-icon size="lg" [icon]="['far', 'dot-circle']"></fa-icon>
            <span class="d-inline d-md-none">&nbsp;Non pris en charge</span>
          </span>
        } @else {
          <span class="text-info" [ngbTooltip]="'Pris en charge par ' + item.handledBy">
            <fa-icon size="lg" [icon]="['far', 'clock']"></fa-icon>
            <span class="d-inline d-md-none">&nbsp;Pris en charge par {{item.handledBy}}</span>
          </span>
        }
      } @else {
        @if(item.partial) {
          <span class="text-warning" [ngbTooltip]="'Accepté partiellement par ' + item.handledBy">
            <fa-icon size="lg" icon="check"></fa-icon>
            <span class="d-inline d-md-none">&nbsp;Accepté partiellement par {{item.handledBy}}</span>
          </span>
        } @else if(item.accepted) {
          <span class="text-success" [ngbTooltip]="'Accepté par ' + item.handledBy">
            <fa-icon size="lg" icon="check"></fa-icon>
            <span class="d-inline d-md-none">&nbsp;Accepté par {{item.handledBy}}</span>
          </span>
        } @else {
          <span class="text-danger" [ngbTooltip]="'Rejeté par ' + item.handledBy">
            <fa-icon size="lg" icon="times"></fa-icon>
            <span class="d-inline d-md-none">&nbsp;Rejeté par {{item.handledBy}}</span>
          </span>
        }
      }
    </td>
    <td>
      <span class="d-inline d-md-none">Utilisateur : </span>
      <a target="_blank"
         [href]="(crmUrl | async) + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + item.contact.crmId">{{ item.contact.firstname }} {{ item.contact.lastname }}</a>
    </td>
    <td>
      <span class="d-inline d-md-none">Compte : </span>
      <a target="_blank"
         [href]="(crmUrl | async) + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DAccounts%26action%3DDetailView%26record%3D' + item.contact.account.crmId">{{ item.contact.account.name }}</a>
    </td>
    <td>
      <span class="d-inline d-md-none">Date de la demande : </span>
      {{ item.date | date:'dd/MM/yyyy' }}
    </td>
    <td class="d-none d-md-table-cell">
      @if(!item.forContact) {
        @if(item.coords) {
          {{ item.coords.email }}
        } @else {
          Contact introuvable ou supprimé
        }
      } @else {
        <a target="_blank"
           [href]="(crmUrl | async) + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + item.forContact.crmId">{{ item.forContact.firstname }} {{ item.forContact.lastname }}</a>
      }
    </td>
  </ng-template>
</ls-dynamic-table>

<app-dynamic-modal-form
  title="Annulation de la prise en charge"
  [actions]="forceUntakeActions"
  [object]="toUntake"
  (onSubmit)="untakeHandler(toUntake)">
  <ng-template>
    <p>Êtes-vous sûr de vouloir annuler la prise en charge par {{toUntake.handledBy}} ?</p>
  </ng-template>
</app-dynamic-modal-form>
